import axios from './axios';

export const fetchTradeUpAvailability = async () => {
    const response = await axios.get('/cardInventory/variation-trade-up');
    return response.data;
};

export const executeVariationTradeUp = async (variationID, rarity, inventoryIDs) => {
    const response = await axios.post('/cardInventory/variation-trade-up', { variationID, rarity, inventoryIDs });
    return response.data;
};

export const executeVariationUpgrade = async (variationID, rarity, inventoryIDs) => {
    const response = await axios.post('/cardInventory/variation-upgrade', { variationID, rarity, inventoryIDs });
    return response.data;
};
